import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, canonical, schema }) => {
    const location = useLocation();
    const baseUrl = 'https://mbwit.net';

    // Default canonical URL logic:
    // If 'canonical' prop is provided, use it.
    // Otherwise, generate it from current path.
    // Clean up trailing slashes except for the root domain.
    let canonicalUrl = canonical || `${baseUrl}${location.pathname}${location.search}`;

    // Ensure root domain doesn't end with double slash if pathname is '/'
    if (location.pathname === '/' && !canonical) {
        canonicalUrl = baseUrl;
    } else if (!canonical) {
        canonicalUrl = canonicalUrl.replace(/\/$/, "");
    }

    const displayTitle = title.includes("MBW Techimpex") ? title : `${title} | MBW Techimpex`;

    return (
        <Helmet>
            <title>{displayTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={displayTitle} />
            <meta property="og:description" content={description} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={canonicalUrl} />
            <meta property="twitter:title" content={displayTitle} />
            <meta property="twitter:description" content={description} />

            {/* Structured Data (Schema.org) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
